export const config = {
  baseURL:
    process.env.NODE_ENV === "development"
      ? "https://api.3beep.io/"
      : // : "http://localhost:8080/",
        "https://api.3beep.io/",
  secret: "TMJ6cFvi5LwKUtyAqrIH",
};
